var _regeneratorRuntime = require("/home/lagexpress/eduardoceballos/radiolagauchita-pwa/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/home/lagexpress/eduardoceballos/radiolagauchita-pwa/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectWithoutProperties = require("/home/lagexpress/eduardoceballos/radiolagauchita-pwa/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _slicedToArray = require("/home/lagexpress/eduardoceballos/radiolagauchita-pwa/node_modules/@babel/runtime/helpers/slicedToArray");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("react-firebaseui-localized", ["React"], t) : "object" == typeof exports ? exports["react-firebaseui-localized"] = t(require("react")) : e["react-firebaseui-localized"] = t(e.React);
}(this, function (e) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/dist/", r(r.s = 1);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0),
        o = r.n(n);

    var i = function i(e) {
      var _Object = Object(n.useState)({
        loaded: !1,
        error: !1
      }),
          _Object2 = _slicedToArray(_Object, 2),
          t = _Object2[0],
          r = _Object2[1],
          o = Object(n.useRef)();

      return Object(n.useEffect)(function () {
        o.current = document.createElement("script"), o.current.src = e, o.current.async = !0;

        var t = function t() {
          return r({
            loaded: e,
            error: !1
          });
        },
            n = function n(e) {
          o.current.remove(), r({
            loaded: !1,
            error: e
          });
        };

        return o.current.addEventListener("load", t), o.current.addEventListener("error", n), document.body.appendChild(o.current), function () {
          o.current.removeEventListener("load", t), o.current.removeEventListener("error", n);
        };
      }, [e]), [t.loaded, t.error];
    };

    function u() {
      return (u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var c = function c(e) {
      return "https://www.gstatic.com/firebasejs/ui/4.1.0/firebase-ui-auth__".concat(e, ".js");
    },
        a = "firebaseui_container";

    t.default = function (_ref) {
      var e = _ref.auth,
          t = _ref.config,
          r = _ref.lang,
          s = _ref.firebase,
          f = _objectWithoutProperties(_ref, ["auth", "config", "lang", "firebase"]);

      var _i = i(c(r)),
          _i2 = _slicedToArray(_i, 2),
          l = _i2[0],
          d = _i2[1],
          p = Object(n.useRef)();

      return Object(n.useEffect)(function () {
        window.firebase = s;
      }, []), Object(n.useEffect)(function () {
        if (l) {
          if (d) throw d;

          _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var r;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    r = window.firebase.apps.find(function (_ref3) {
                      var e = _ref3.name;
                      return e.endsWith("-firebaseui-temp");
                    });
                    _context.t0 = r;

                    if (!_context.t0) {
                      _context.next = 5;
                      break;
                    }

                    _context.next = 5;
                    return r.delete();

                  case 5:
                    p.current && (p.current.innerHTML = "");
                    new window.firebaseui.auth.AuthUI(e).start("#".concat(a), t);

                  case 7:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();
        }
      }, [e, t, d, l]), o.a.createElement(o.a.Fragment, null, o.a.createElement("link", {
        type: "text/css",
        rel: "stylesheet",
        href: "https://www.gstatic.com/firebasejs/ui/4.1.0/firebase-ui-auth.css"
      }), o.a.createElement("div", u({}, f, {
        ref: p,
        id: a
      })));
    };
  }]);
});